export enum EnumOpcoesDelivery {
    Entrega,
    Retirada,
  }